__turbopack_context__.v({
  "container": "OutletSearchCard-module-scss-module__5ujeSq__container",
  "searchInput": "OutletSearchCard-module-scss-module__5ujeSq__searchInput",
  "subtitle": "OutletSearchCard-module-scss-module__5ujeSq__subtitle",
  "title": "OutletSearchCard-module-scss-module__5ujeSq__title",
});
